import React from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton
} from '@mui/x-data-grid';
import { Divider, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { DebounceInput } from 'react-debounce-input';

import { useResponsive } from '../../services/hooks';
import { CssTextField } from '../others/CssTextField';
import { OrderAdvancedFilter } from './OrderAdvancedFilter';

export const DataGridToolbar = props => {
  const { onOpenSidebar, hideSidebar, miniView, searchCallback, showAll = false, advancedFilter = false, filterToolbar = true, columnsToolbar = true, densityToolbar = true, exportToolbar = false, containerStyle = {}, searchStyle = {} } = props;
  const mdUp = useResponsive('up', 'md');

  const handle = () => {
    if (!mdUp) {
      onOpenSidebar();
    } else {
      hideSidebar();
    }
  };

  return (
    <GridToolbarContainer style={{ display: 'flex', flexWrap: 'wrap', ...containerStyle }} >
      { miniView ? null
        : <Tooltip title="Pokaż/Ukryj menu">
          <IconButton onClick={handle} color="primary" sx={{ mr: mdUp ? 4 : 2 }}>
            <MenuIcon />
          </IconButton>
        </Tooltip>
      }
      {(miniView || showAll) && !advancedFilter
        ? <DebounceInput
          debounceTimeout={1000}
          style={{ width: 100, marginRight: 8, ...searchStyle }}
          element={CssTextField}
          placeholder="Wyszukaj..."
          onChange={e => searchCallback(e.target.value)}
          variant="standard"
        />
        : advancedFilter
          ? <OrderAdvancedFilter searchCallback={searchCallback} />
          : null }
      {miniView && filterToolbar ? <GridToolbarFilterButton style={{ color: '#00AB55' }} /> : null}
      {columnsToolbar ? <GridToolbarColumnsButton style={{ color: '#00AB55' }} /> : null}
      {densityToolbar ? <GridToolbarDensitySelector style={{ color: '#00AB55' }} /> : null}
      {exportToolbar ? <GridToolbarExport style={{ color: '#00AB55' }} /> : null}
    </GridToolbarContainer>
  );
};
